import { useInsiderFeatureEligibility } from "@faire/retailer-visitor-shared/hooks/insider/useInsiderFeatureEligibility";
import { useInsiderMembershipInformation } from "@faire/retailer-visitor-shared/hooks/insider/useInsiderMembershipInformation";
import { useNationality } from "@faire/retailer-visitor-shared/hooks/retailer/useNationality";
import { useSettingInsiderPhoneSuppportEnabled } from "@faire/retailer-visitor-shared/settings/useSettingInsiderPhoneSuppportEnabled";
import { useMemo } from "react";

export type IInsiderSimplifiedBenefit =
  | "FREE_SHIPPING"
  | "FREE_IMPORT_DUTIES"
  | "FREE_SHIPPING_AND_DUTIES"
  | "EARLY_ACCESS"
  | "PHONE_SUPPORT";

/** Lists the Insider membership benefits to be advertised. */
export function useInsiderAdvertisedBenefits(): IInsiderSimplifiedBenefit[] {
  const { insiderMembershipInformation } = useInsiderMembershipInformation();
  const { hasPhoneSupport, hasFreeDutyAdvertising } =
    useInsiderFeatureEligibility();
  const { isUK } = useNationality();
  const isPhoneSupportEnabled = useSettingInsiderPhoneSuppportEnabled();

  return useMemo(() => {
    const advertisedInsiderBenefits: IInsiderSimplifiedBenefit[] = [];

    if (isUK && isPhoneSupportEnabled) {
      advertisedInsiderBenefits.push("FREE_SHIPPING_AND_DUTIES");
    } else {
      if (insiderMembershipInformation?.has_free_shipping) {
        advertisedInsiderBenefits.push("FREE_SHIPPING");
      }

      if (hasFreeDutyAdvertising) {
        advertisedInsiderBenefits.push("FREE_IMPORT_DUTIES");
      }
    }

    advertisedInsiderBenefits.push("EARLY_ACCESS");

    if (hasPhoneSupport) {
      advertisedInsiderBenefits.push("PHONE_SUPPORT");
    }

    return advertisedInsiderBenefits;
  }, [
    isUK,
    isPhoneSupportEnabled,
    hasPhoneSupport,
    insiderMembershipInformation?.has_free_shipping,
    hasFreeDutyAdvertising,
  ]);
}
